<template>
  <a-modal v-model="visible" title="授权渠道商 " @ok="handleOk">
      <template slot="footer">
            <a-button key="submit" type="primary"  @click="handleOk">
            确定
            </a-button>
            <a-button key="back"  @click="handleCancel" >
            取消
            </a-button>
        </template>
    <a-transfer
      :data-source="channelPartners"
      :titles="['全部渠道商', '已选择']"
      :showSelectAll="false"
      :target-keys="targetKeys"
      :selected-keys="selectedKeys"
      :render="item => item.title"
      :disabled="disabled"
      @change="handleChange"
      @selectChange="handleSelectChange"
    />
  </a-modal>
</template>
<script>
export default {
  data() {
    // const oriTargetKeys = mockData.filter(item => +item.key % 3 > 1).map(item => item.key);
    return {
      visible: false,
      targetKeys: [],
      selectedKeys: [],
      disabled: false,
      channelPartners:[],
      mdseIds:[],
    };
  },
  methods: {
    init(){
      this.$http.post('distributor/getAllDistributor').then((res)=>{
        let channelRows =res.rows;
        let channelPartners = [];
        if (channelRows&&channelRows.length>0) {
          channelRows.map((item,index)=>{
            let channel = item.split(':');
            channelPartners.push({
              title:channel[1],
              key:channel[0],
              disabled:false,
              description:''
              })
          })
        }
        this.channelPartners = channelPartners;
      })
    },
    showModal(mdseIds) {
      this.init();
      this.mdseIds = mdseIds;
      this.visible = true;
    },
    handleOk(e) {
      let params = {
        distributorIds:this.selectedKeys,
        mdseIds:this.mdseIds,
      }
      this.$http.post('merchandise/batchAuth',params).then(res=>{
        if (res.result) {
          this.$message.info('授权成功');
          this.$emit('getdata');
          this.handleCancel();
        }else{
          this.$message.warning(res.message);
        }
        
      })
      this.visible = false;
    },
    handleCancel(e) {
      this.selectedKeys = [];
      this.targetKeys = [];
      this.visible = false;
    },
    handleChange(nextTargetKeys, direction, moveKeys) {
      this.targetKeys = nextTargetKeys;
      this.selectedKeys =nextTargetKeys;
    },
    handleSelectChange(sourceSelectedKeys, targetSelectedKeys) {
      this.selectedKeys = [...sourceSelectedKeys, ...targetSelectedKeys];
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.ant-transfer-list-header-selected{
    span:first-child{
        visibility: hidden
    }

}
/deep/.ant-btn-primary {
    background-color: #1890ff!important;
    border-color: #1890ff!important;
} 
</style>
